import { Grid, Typography, Box } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleFontPreview } from "../helpers";
import images from "../../../../../global-styles/images";

interface IProps {
  product: any;
  previewAgent: boolean;
  branding: any;
  technology: string;
  handleBtnPosition: (category: any) => void;
  ClickedCat: any;
  ClickedCatFbsVal: any;
}

const QRCodePreview = ({
  product,
  previewAgent,
  branding,
  ClickedCatFbsVal,
  ClickedCat,
  technology,
}: IProps) => {
  return (
    <Grid
      item
      xs={12}
      mt={previewAgent ? "30px" : "15px"}
      sx={{ padding: previewAgent ? "0px 80px" : "0 20px" }}
    >
      <Typography
        sx={{
          color: branding?.[brandingConstants.mainTitleColor],
          fontWeight: "900",
          fontStyle: branding?.[brandingConstants.mainTitleFontStyle],
          fontFamily: branding?.[brandingConstants.mainTitleFontFamily],
          fontSize: handleFontPreview(
            branding?.[brandingConstants.mainTitleFontSize],
            previewAgent
          ),
          textAlign: "center",
          marginTop: previewAgent ? "30px" : "5px",
        }}
      >
        {product?.qrSettings?.qrHeading || "Scan this QR code with your phone"}
      </Typography>

      <Typography
        sx={{
          color: branding?.[brandingConstants.subTitleColor],
          fontWeight: branding?.[brandingConstants.subTitleFontWeight],
          fontStyle: branding?.[brandingConstants.subTitleFontStyle],
          fontFamily: branding?.[brandingConstants.subTitleFontFamily],
          fontSize: handleFontPreview(
            branding?.[brandingConstants.subTitleFontSize],
            previewAgent
          ),
          textAlign: "center",
          marginTop: previewAgent ? "30px" : "5px",
        }}
      >
        {product?.qrSettings?.qrSubHeading ||
          "To provide additional context on your query, please scan the QR code below. You will have an option to submit a screenshot, screen recording or audio recording."}
      </Typography>

      <Typography
        sx={{
          color: branding?.[brandingConstants.subTitleColor],
          fontWeight: branding?.[brandingConstants.subTitleFontWeight],
          fontStyle: branding?.[brandingConstants.subTitleFontStyle],
          fontFamily: branding?.[brandingConstants.subTitleFontFamily],
          fontSize: handleFontPreview(
            branding?.[brandingConstants.subTitleFontSize],
            previewAgent
          ),
          textAlign: "center",

          marginTop: previewAgent ? "30px" : "5px",
        }}
      >
        After scanning the qr code with your mobile, enter the PIN shown on this
        screen in your mobile and then close this screen
      </Typography>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          marginTop: previewAgent ? "30px" : "10px",
        }}
      >
        <Box>
          <img
            src={images.qrCode}
            alt="qr-code"
            style={{
              width: previewAgent ? "250px" : "100px",
              height: previewAgent ? "250px" : "100px",
            }}
          />
        </Box>
        <Typography
          sx={{
            color: branding?.[brandingConstants.subTitleColor],
            fontWeight: branding?.[brandingConstants.subTitleFontWeight],
            fontStyle: branding?.[brandingConstants.subTitleFontStyle],
            fontFamily: branding?.[brandingConstants.subTitleFontFamily],
            fontSize: handleFontPreview(
              branding?.[brandingConstants.subTitleFontSize],
              previewAgent
            ),
            marginTop: previewAgent ? "30px" : "5px",
          }}
        >
          PIN: 8657
        </Typography>
      </Box>

      <Box></Box>
    </Grid>
  );
};

export default QRCodePreview;
